export enum PageTypeKeys {
  SET_FORCE_HIDE_NAV = 'page/SET_FORCE_HIDE_NAV',
}

export interface IPageState {
  forceHideNav: boolean;
}
